import React, { FC } from 'react';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import useExperienceEditorPlaceholder from '../../hooks/useExperienceEditorPlaceholder';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import { ProductSeriesView360Props } from './types/productSeriesView360.types';
import { ProductSeriesView360Model } from './models/productSeriesView360.model';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import './styles.scss';

const ProductSeriesView360: FC<ProductSeriesView360Props> = (props) => {
    const model = new ProductSeriesView360Model(props);

    const apiResponse = isEmptyResponse(props);
    const isEEActive = isEditorActive();
    const isPlaceholderShown = useExperienceEditorPlaceholder(props);

    // Component is unreleased
    if (model.isUnreleased) {
        return <UnreleasedComponent/>
    }

    //  star node opened directly in EE
    if (isPlaceholderShown) {
        return <ExperienceEditorComponentPlaceholder image={model.thumbnailEE} componentName={model.componentName}/>;
    }

    // not opened from star node
    // data missing when navigating via from products node
    if (!apiResponse && isEEActive) {
        return <EmptyApiDataMessage componentName={model.componentName}/>;
    }

    // No data and not in EE
    if (!apiResponse && !isPlaceholderShown && !isEEActive) {
        return null;
    }

    if (!model.iframeUrl) {
        return null;
    }

    return (
        <div className="series-view-360">
            <h2>{model?.title}</h2>
            <iframe src={model?.iframeUrl} allowFullScreen title={model?.iframeUrl}></iframe>
        </div>
    );
};

export default ProductSeriesView360;
